export default __webpack_public_path__ + "static/media/tripBoomerang.89c1882c.png";